export default __webpack_public_path__ + "static/media/bg1.4a425bc0.png";